module.exports = __webpack_public_path__ + "od-thumbs-up-green/od-thumbs-up-green-ffb93cc88ea71990e668bf8db3cfcdd0.png";